module.exports = __webpack_public_path__ + "static/img/ic_division.f193d4bb.svg";